import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';

import ConditionalWrapper from '@polyai/common/utils/conditionalWrapper';
import GridContent from '@polyai/ui/components/atoms/GridContent';

import ErrorBoundary from '../ErrorBoundary';
import Helmet from '../Helmet';

const LazyScreen = ({
  title,
  noWrap,
  children,
}: PropsWithChildren<{
  title?: string;
  noWrap?: boolean;
}>) => (
  <ErrorBoundary>
    <Suspense fallback={null}>
      <Helmet title={title} />
      <ConditionalWrapper
        condition={!noWrap}
        wrapper={children => <GridContent>{children}</GridContent>}
      >
        {children}
      </ConditionalWrapper>
    </Suspense>
  </ErrorBoundary>
);

export default LazyScreen;
